import { setLoadingServicesParams, addLoadingServiceParam, clearLoadingServicesParams } from './actions';
export var LoadingServiceType;
(function (LoadingServiceType) {
    LoadingServiceType["Insurance"] = "Insurance";
    LoadingServiceType["Transfer"] = "Transfer";
})(LoadingServiceType || (LoadingServiceType = {}));
const initialState = {
    id: [],
    rfisc: [],
    subType: [],
    type: []
};
export const loadingServicesParamsReducer = (state = initialState, action) => {
    switch (action.type) {
        case setLoadingServicesParams.toString():
            return action.payload;
        case addLoadingServiceParam.toString():
            const newState = Object.assign({}, state);
            const actionPayload = action.payload;
            for (const param in actionPayload) {
                if (actionPayload[param]) {
                    newState[param] = [...newState[param], ...actionPayload[param]];
                }
            }
            return newState;
        case clearLoadingServicesParams.toString():
            return initialState;
        default:
            return state;
    }
};
